"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarsFilterCopy = void 0;
var react_1 = __importDefault(require("react"));
var CarsFilter_module_scss_1 = __importDefault(require("./CarsFilter.module.scss"));
var Loader_1 = require("../loader/Loader");
var Pagination_1 = require("../pagination/Pagination");
var CardAuto_1 = require("../cardAuto/CardAuto");
var CardAutoHorizontal_1 = require("../cardAutoHorizontal/CardAutoHorizontal");
var useCarsFilterCopy_1 = require("../../hook/useCarsFilterCopy");
var CarsFilterCopy = function () {
    var _a = (0, useCarsFilterCopy_1.useCarsFilterCopy)(), viewMode = _a.viewMode, isLoading = _a.isLoading, error = _a.error, sortedCars = _a.sortedCars, pagination = _a.pagination, handleScrollTop = _a.handlers.handleScrollTop;
    if (isLoading) {
        return react_1.default.createElement(Loader_1.Loader, null);
    }
    if (error) {
        return react_1.default.createElement("div", { className: CarsFilter_module_scss_1.default.error }, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445");
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "".concat(CarsFilter_module_scss_1.default.filter_cars, " ").concat(CarsFilter_module_scss_1.default[viewMode]) }, sortedCars.map(function (car) {
            return viewMode === 'horizontal' ? (react_1.default.createElement(CardAutoHorizontal_1.CardAutoHorizontal, __assign({ key: car.id }, car))) : (react_1.default.createElement(CardAuto_1.CardAuto, __assign({ key: car.id }, car)));
        })),
        pagination.totalPages > 1 && (react_1.default.createElement("div", { onClick: handleScrollTop },
            react_1.default.createElement(Pagination_1.Pagination, { currentPage: pagination.currentPage, totalPages: pagination.totalPages })))));
};
exports.CarsFilterCopy = CarsFilterCopy;
